export const fundingSource = () => {
	return {
		fundingAmount: 0,
		fundingTypeId: 0,
		fundingDescription: '',
		// fundingTypeName: '',
	};
}; //maybe use a class for a model? ks
